var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDTerengganu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -20 1240 697",
    preserveAspectRatio: "xMidYMid slice",
    id: "svgN",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "N32",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M734.9 494.1l1.3-3.4v-1.3l-.9-1.5-.2-1.5-1.5-2.6-.9 1.9-7.9-1.5-1.7 1.7-.6-1.5L700 479l-4.7-1.5-4.7-.2-2.6-2.6 2.1-3.6-1.7-1.9c-5.6-.2-6.9-9.4-6.9-9.4l-3.4-1.9c-4.1 6.6-3.2-3.6-3.2-3.6l-6.9-3.6v-1.8l-6-7-4.6.2-8.9 5.8-3.6-3.4-4.1-1.4-4.6 4.8-2.9 3.5c.5.3 1.2.6 2.1.7l-2.1 4.8-3.6 2.4.8 8.8 2.5 2.4s.4 1.1-7.2-.5c0 0-6.4-2.8-8.4 10.9 0 0-.8 4-4.4 1.2 0 0-4.4.9-2.4 8.5 2 7.6-.8 3.2-2.4 6.4-1.6 3.2-.4 9.7-.4 9.7l-.3 8.6-7.2 5.2s5.3 10.5 10.6 10.1l8-4.4 4.8-1.6 2.4-1.6h2.8l4.8 2.4 11.4 1.8 4 2s.4 3.8 6.1 5.4l4.4.8 4.8 8.4 3.6.4 2 3.6 6 1 2.6-2.2 2.4 5 2.4.7 3.6-1.7 3.4 2.6 1.9 4.3 6 7.2-1.6 1.9 2.3 4.8 8.5 14 2.8-2-.7-2.6-3.5-5.2 4.4-.8 1.9-4.1 1.9-6.5-.5-3.4-2.2-5.3.7-7-.5-5.5-2.4-3-2.4-.6-1-4.2.8-2 .4-6 2-2.2 2.4-.8.2-4 1-1-.8-3.4.8-1-1.8-2.6v-2.8l-1.2-1.4.8-1.6.9.6-.8-3.7-.9-1.3.2-1.3 4.9 1.1 2.4-1.7 3.4 2.4 1.9-1.9c1.1-.9 6-1.9 6-1.9l1.1 1.3c-2.4 7.9 4.3 0 4.3 0l1.1-.2.2-3.9-5.4-.6 3-1.7 2 .5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "N31",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M739.8 490.9l-3.6-.2-1.3 3.4-1.5-.4-3 1.7 5.4.6-.2 3.9-1.1.2s-6.6 7.9-4.3 0l-1.1-1.3s-4.9 1.1-6 1.9l-1.9 1.9-3.4-2.4-2.4 1.7-4.9-1.1-.2 1.3.9 1.3.8 3.7.3.2h2.6l3.4 3.2H735l2.2-1.6 4 .8 1.4.6.9-2.5-1.1-1.5-.9-2.4-.5-3.5.2-.9 1.1-1.4 1.5-3 .8-.2-1.7-.6-3.1-3.4z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "N30",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M756.1 472.2l-2.4-2.6-3.9-6.5-3.5-7.6v-1.9l-7.5 3.6-4.5.4-2.6-1.1-3.2.2-2.6 1.9-1.7-1.3.6-1.7.2-3.2-3-2.6-.9-3h3.6l1.3-2.6V436l-1.3-6.9-5.1 1.9-6.2 4.1.6 1.1-3 4.7-1.7-2.4-2.1-.2-.9.9-.9-1.9-2.6-1.5-4.9 2.9-1.4-1.9-9.8 3.6-2.6-12.2-6 3.6-5.3 7.4-4.6 9.8-.2-.2v1.8l6.9 3.6s-.9 10.3 3.2 3.6l3.4 1.9s1.3 9.2 6.9 9.4l1.7 1.9-2.1 3.6 2.6 2.6 4.7.2 4.7 1.5 22.5 5.4.6 1.5 1.7-1.7 7.9 1.5.9-1.9 1.5 2.6.2 1.5.9 1.5v1.3l3.6.2 3 3.6 1.7.6 1.3-.4 1.2-1.1.3-3.2 2.1-.2h1.8l-.1-2.9v-2.9l.3-1.8 2.6-2.1.8-2.9.8-1.5-.6-1.4 1.1-2.4z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "N29",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M706.4 439.3l.9-.9 2.1.2 1.7 2.4 3-4.7-.6-1.1 6.2-4.1 5.1-1.9 1.3 6.8v8.4l-1.3 2.6h-3.6l.8 3 3 2.5-.2 3.3-.6 1.7 1.7 1.3 2.6-2 3.2-.2 2.6 1.1 4.5-.4 7.5-3.6.1-4.3-.2-3.7-.9-3.1-1.9-8.4.4-6.3 3.4-4.4 2.5-.5 2.3-2.2-1.1-3.8.2-2.7-1.1-2.5-3.6-9.3-.1-.3-3.2 1.5-16.3 1.9-3.1 1.2-6.3-3.6-3.6 5.1-4 3.6-2-1.2-2.4 3.3-1.6 4.4 2.1 6.4-2.4 3.6-.2 7.2-.4.2 2.6 1.5z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "N28",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M742.9 394.6l-1.9-4.8-.2-2.2h2.7l1.1.3.9-1.2-1.2-3.6.5-2 .5-3.5-2.6.4-3.4-3 1.1-2.1-2.3-2.6-.5 2-1.7-1.7-4.7.4-4.1-3.2.4-2.8-2.4-2.6-5.6-.6-3.4 1.5-3.9-5.6s-1.9-2.1-3.4-1.7c-1.5.4-4.3.9-4.3.9l-2.4 1.3-4.7-.9.2 2.6-.9 1.9.6 3-1.5 2.1.6 4.3 2.6 13.3 2.1 6.6-.9 1.3 1.5 2.1-.2 5.4 1.1 7.1 1.7 1.9-.6 3.4 1.7 1.7 2.3-3.3 1.9 1.2 4.1-3.6 3.6-5 6.2 3.6 3.1-1.2 16.3-1.9 3.2-1.5-2.9-8.2-.3.5z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "N27",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M731.3 356.3l1.2 3.9 3.7 3.6 2.3 4.3-.5 2.1 2.3 2.6-1.1 2.2 3.4 3 2.7-.4v-.4l-1.2-1.7-5.7-13.9.8-6.1.7-.4-2.4-.5z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "N26",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M770.4 343l-1.5.9v1.3l-.9.9 1.1 2 1.1.7 1.3-.2-.2-1.7 1.1-1.5v-1.3l-2-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M739.5 348.5l-1.1-3-2.1-4.2-1.7.8-1.4-3.6-1.5-1.5.8-1.4-2.4-4.1-.7-1.2h-.5l-3.1 1.4v2.2l-4.6 3.4-5-.2-3.4-4.8-3.8-3.6-3.6 3.4-2.4.5-5.4 7.8-.4 3.2-1.9-1.1-1.9 4.5-2.4-1.3.2-1.3-2.4-.6-1.3 2.8-3.6-1.3.6 24.2 7.1-1.9 1.5-3.9-3.2-2.8 7.5-3.6 4.7.9 2.4-1.3s2.8-.4 4.3-.9c1.5-.4 3.4 1.7 3.4 1.7l3.9 5.6 3.4-1.5 5.6.6 2.4 2.6-.4 2.8 4.1 3.2 4.7-.4 1.7 1.7.5-2 .5-2.1-2.4-4.3-3.6-3.6-1.3-3.9 6.2-1.7 2.4.5 1.1-.6 1.5-.8-3-5.3z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "N25",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M703.8 418.4l1.7-4.3.1-.1-1.7-1.7.6-3.4-1.7-1.9-1.1-7.1.2-5.4-1.5-2.1.9-1.3-2.1-6.6-2.6-13.3-.6-4.3 1.5-2.1-.6-3 .9-1.9-.2-2.6-7.5 3.6 3.2 2.8-1.5 3.9-7.1 1.9-.6-24.2 3.6 1.3 1.3-2.8 2.4.6-.2 1.3 2.4 1.3 1.9-4.5 1.9 1.1.4-3.2 5.4-7.8-3.4-8.2-9.8-2.6-1-11.5-1-.3.1.1-1.4 1-2.2.7-1.2 1.4 1.2 3.1-6 3.6h-1.9l-1.7 1.9 1.2 1.9-1.7 2.2-2.2-1.4s-5.5 5-10.6-.5l-1.4 1.7s-2.6-1-2.6-1.9c0-1-4.3-4.3-4.3-4.3l-3.6-1.9-.5 3.8s4.1 9.8.7 12.7l-2.4-.7-1.2 1.7-4.1.2-1.4-1.9-2.9 1.2s1.7 6.2-2.2 6.2c-3.8 0-9.6-2.4-9.6-2.4l-3.6 5.8-1.9 1-2.2-.7s-2.6 3.8-10.3 1l-3.4 1.2-4.1-.5.2 4.1-.7 6.5s3.1 5.8-.2 7c-3.4 1.2-6.2 3.6-6.2 3.6l-5.5 1.7-.2 7.2-.9 5.9 1.1.3 1.2 1.8 2.6 1.4 2.4 3.6 1.8 3.6-1.4 2.4 2 1.6 2.6 3-1.4 1-4.6.8s0 .8 1.2 2.4l1.6 2-.8 2.6-1.4 4-2.4-.8-3.6 1.6-.4 3.4.2 2s2.8 4.4 2 9.7c0 0 .4 2 3.2 2.4 2.8.4 5.2 1.6 4 4.4-1.2 2.8 4 .8 4 .8l2.2.4h7l2 1 2 2.4 1.2.8 2.4-.8-.2-2.8 1.2-1.8h1.6l1.4-1.2 2.4 2 2.8 4.4 2 .4 3.2 4.8s-1.7 4 1.1 5.7l2.9-3.5 4.6-4.8 4.1 1.4 3.6 3.4 8.9-5.8 4.6-.2 6.2 7.2 4.6-9.8 5.3-7.4 6-3.6 2.6 12.2 9.8-3.6 1.4 1.9 5.3-3.1.2-7.2 2.4-3.6-2-6.6z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "N24",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M687.9 309.8l-2.6-2.1-.7-6-8.6-7.9-4.3-9.4-3.1 1.9-5.3-7s-1-4.1-3.1-7.2c-2.2-3.1-4.8.7-4.8.7l-4.9-2.8-.6 1.1-2.5-.8-5.4.3-3.9-.8-1.1 5.4 1.2 1.9 2.3 1.2 1.4-1.4.6 1.1.2 1.9h-3.2l-.6 1.2.8 1.2-1.4 1.1v-.8l-2.2-.2.2-1.7-1.9-.2.5 2.6 1.2 1.5.6 3.9-3.1.2-1.4 2 1.4 3.7-1.7.9.6 2.9 2-.6.9 2.2-2.2.3.2 1.9 1.5.3-2.5 2-1.9 1.4 1.2 1.4h-1.2v1.7l.9 3.1c.6 4-3.2 1.5-3.2 1.5l-2 1.5-.8 3.4-1.2 3.6-1.7-1.5-.2 2.2-1.7 1.2-3.7-1.4-2-.9-1.2.3-3.1-.2c-1.5-2.6-3.7.2-3.7.2l-1.1 2.9-1.5 1.5-1.9 3.1-2.6 6.5-2.5 2.8H594c-2.6 2 2.6 5.4 2.6 5.4l.9 1.5-1.2.9c-2.2 2.2 3.1.3 3.1.3l1.3.5-.1-1.8 4.1.5 3.4-1.2c7.7 2.9 10.3-1 10.3-1l2.2.7 1.9-1 3.6-5.8s5.8 2.4 9.6 2.4 2.2-6.2 2.2-6.2l2.9-1.2 1.4 1.9 4.1-.2 1.2-1.7 2.4.7c3.4-2.9-.7-12.7-.7-12.7l.5-3.8 3.6 1.9s4.3 3.4 4.3 4.3c0 1 2.6 1.9 2.6 1.9l1.4-1.7c5 5.5 10.6.5 10.6.5l2.2 1.4 1.7-2.2-1.2-1.9 1.7-1.9h1.9l6-3.6-1.2-3.1 1.2-1.4 2.2-.7 1.2-.5z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "N21",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M636.9 241.9l2.5-.6-.5-.5s-.1-1.2-.1-2.9l-1.9.5-1.9-.6-2.2-1.4-.8.8-.6 2-2.5-1.4-3 2.8-2.8 2.6-3.6 3.4-4.3-1.2-4.1 3.4-9.4-10.1 1.4-2.4-1.4-1.7-3.8-.7-1.9 1-5.8-7-1.2 2.9-4.8 2.4-10.6 7.2-3.6-.5-10.1-7.9-2.4-1.2V226l.7-3.1-.5-3.6-.5-4.6-2.4-4.8-4.8-.2-3.8-1.7.7-13-1.9-1.4-4.8 3.1-2.4-1.9 1.4-5.3-.7-4.8s-5.3-4.8-6-4.8c-.7 0-2.2-5.8-2.2-5.8l-7.4-1.7.2.5-1 2.6 2.2 4.6-2.4 3.6.7 1.4-1.7 2.9-.2 6-2.2 3.1 2.6 4.6-2.6.7s-2.2-.7-3.1-.7c-1 0-5 3.1-5 3.1l-4.3 6.5-4.8-1 1-2.6-8.6-3.6-5 2.6-4.8-3.1h-1l-.1.8-1.5 1.1-1.1-.3-.8 1.8.1 2.6-.1 2.1.5 2-1.7 1.8-.8 3-.5 2.3-.5 1.2.5 2-.6 1.8 1.1 2.1-1.1 2.7.2 4.5-.6 2 .3 1.8 1.5 1.5.2 4.8-1.2 2.4-.9 1.7.8 2 2.4-.2 3.8.6 1.2 2.3 2.4.5h1.2l2 1.8 1.7.3.3 1.7 2.1 1.4 1.2 3.2 2.1.8.9-.2 2.9 1.4 1.5.9-.1.9 2.7 2.7.9.9-2.7 2.1.2 2.7-1.2.5-1.5.6-2.4 2.4 2 1.5.8 2.3 1.1 2.1-.9 1.2.3 2 1.4 1.5-.5 1.2 1.2.9-1.5 3.6-2 1.1-1.5.2-.1 1.8-.6 1.8 1.1 1.5.5 2 1.1.6.9 2.3 2 1.2v2l-1.2 1.5 1.2 1.7v1.2l-1.5.9.2 2.9-.9 2.3-.3.9-.3 1.8-.6 1.7 6 1.2 2-2 3.2.4 5.2 2 5.6 6 4.8-.4 1.2 2.4 4.8 2.4 6.4 3.2-3.2 6.4 2.4 1.2 4 8-2.8 5.6 2.4 5.2 3.2 3.6 1.2 3.2 4-.8 4 5.2 2.4.8 2.8 2.4 2.8-1.2 2.4 2 2.8-.4 4.8 3.6 3.4-2.2 2.2.4 3.2-.8h4.4l1.3.3.9-5.9.2-7.2 5.5-1.7s2.9-2.4 6.2-3.6c3.4-1.2.2-7 .2-7l.7-6.5-.1-2.3-1.3-.5s-5.3 1.9-3.1-.3l1.2-.9-.9-1.5s-5.3-3.4-2.6-5.4h3.4l2.5-2.8 2.6-6.5 1.9-3.1 1.5-1.5 1.1-2.9s2.2-2.8 3.7-.2l3.1.2 1.2-.3 2 .9 3.7 1.4 1.7-1.2.2-2.2 1.7 1.5 1.2-3.6.8-3.4 2-1.5s3.9 2.5 3.2-1.5l-.9-3.1v-1.7h1.2l-1.2-1.4 1.9-1.4 2.5-2-1.5-.3-.2-1.9 2.2-.3-.9-2.2-2 .6-.6-2.9 1.7-.9-1.4-3.7-.2-.5-1.1-.6-3.4-3.6s-4.5 2.2-6.2 1.7l.9-2.5h1.2l-.6-1.9 1.5-1.5-1.4-1.7v-4.6l-1.5-1.7 2-2.2-1.5-1.4V267l3.6-5.1 3.7-1.7h2.5l2.8-3.1-3.7-5.4 4-3.1 1.5-.6 1.9-2.5-1.5-2.2.2-1.4z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "N23",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M636.6 243.3l1.5 2.2-1.9 2.5-1.5.6-4 3.1 3.7 5.4-2.8 3.1h-2.5l-3.7 1.7-3.6 5.1v3.7l1.5 1.4-2 2.2 1.5 1.7v4.6l1.4 1.7-1.5 1.5.6 1.9h-1.2l-.9 2.5c1.7.5 6.2-1.7 6.2-1.7l3.4 3.6 1.1.6.2.5 1.4-2 3.1-.2-.6-3.9-1.2-1.5-.5-2.6 1.9.2-.2 1.7 2.2.2v.8l1.4-1.1-.8-1.2.6-1.2h3.2l-.2-1.9-.6-1.1-1.4 1.4-2.3-1.2-1.2-1.9 1.1-5.4 3.9.8 5.4-.3 2.5.8.6-1.1-.6-.3v-2.6l-6.7-9.6.7-2.4-1.7-9.6-1.7-1.4.7-1.2-1.6-1.6-2.5.6-.4.9z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "N16",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M675 224.4l-4.2-8v-1.5l-1.7-2.7-1.4.7.5.6-.5 1.2.4 1.3v2.3l-1.1-.2-.3 1.2.6 2.1H666l-1.4.4.3.8 1.6 1.3-.2 2.7h.7l2.7 7.4.9-.7 1-1.9 2.9 2.4 1.6-3-.7-1.4.9-.7 1 1.3 1.5-.1z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "671.7,229.3 693.3,236.3 706.3,237  "
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "N15",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M667.7 212.9l1.4-.7-1-1.6-1.2.3.1.8-.6.3.3.8-2.1-.5-.2 1.6.3.7-.6 1 .9 1-.4.6-.9.8-.5.4v1.1l.6.5-.6 1.2.5.6-1.2 3.6.2 1.3 3.6-.1.2-2.7-1.6-1.3-.3-.8 1.4-.4h1.3l-.6-2.1.3-1.2 1.1.2V216l-.4-1.3.5-1.2z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 663.9,
    y1: 224.5,
    x2: 725.2,
    y2: 224.5
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "N14",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M661 215.4l-2.1.1.3 1.6s2-.8 1.5.5l-.5 1 .3.7 1.1-.4 1-.8 1.3-.1 1-.8.4-.6-.9-1.1.6-.9-.3-.7.2-1.6 2.1.5-.3-.8.6-.3-.1-.8 1.2-.3-.6-1-.2-.2-3.4.3-1.2 3.8h-1l.1.9-1.1 1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 665,
    y1: 211.3,
    x2: 686,
    y2: 202.6
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "N8",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M649.4 187.3l-2.9-2.1-2.3-3-2.1-1.5-2.4-.6-5-3.1-2.2-3.8-2.9-3.1-.6-.7-4.5 2.8-11.4 12.3c.2.2.5.4.6.5 1.4 1.2 4.8 1.4 4.8 1.4 3.4-4.3 4.3 6.7 4.3 6.7l.5 5 1.9 3.4 1.7.7.2-5.3 8.2-1.9 5.5 4.3 2.2.2-.2-9.1 6.5-.7 2.2 1.2.5-1.1-2.6-2.5zM628.7 85.8l-.3.8-.6 1.8-.1 1.6.3 1.2-.3 1.7-1.1 1.1.1 1 .7 1.4.7 1.5.2 1.6v1.7l.4 1.2.5.6.7-1.2 1.1-1 .1 2.1 1.2.6.3.9.9-1.4.5-.4 1.2-1.2 1.2-1.6.6-.3.9.5.6-1.8-.3-2.1.6-.8.8-.7.9-1.1.7-.6-1.3-.3h-1.4l-.7-.7h-2.6l-1.2 1.5-.6 1.2-1.1 1.5-.1-1.4.4-1.3 1.1-1.5.3-1.4-.3-.6 1-.8-.4-1-.6-.8-1.1-1.3-.4.3-.9.3-.9-1.2z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "N7",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M603.1 177.9l-.2-4 1-5-1.1-1.2-3.4.3-3-.6-1.4-2-2.7-1.3-2.2-4.8-1.1 5.1-2.6-1-5.4 3.7-1.1-1.7-4.3 3.8.9 3.1v1.6l-2.7 1.1 1.8 4.4-2.4-.4-.6 1.7.5 1.2-.3 3.4-2-.1-1.6.7-3.9 4.4-4.6-3.9-2.3 1.1-.5-.9-1.4 1-.1 1.7-1.3 2 .5 3.5-4.6-1.1-.8 1.5-2.5-2.1-1.3 1.4.7.4-.8 13 3.9 1.7 4.8.2 2.4 4.8.5 4.6.4 3.6-.7 3.1v4.8l2.4 1.2 10.1 7.9 3.6.5 10.6-7.2 4.8-2.4 1.2-2.9 5.7 7 1.9-1 3.9.7 1.4 1.7-1.4 2.4 9.3 10.1 4.1-3.4 4.3 1.2 3.6-3.3 2.9-2.6-.3-.3-1.6 1.8 1.6-1.8-6.6-6.3-2.4-.2-.5-2.6-5.3-3.9 1.2-3.1-1.4-3.4-4.8-3.3 3.3-4.1-.2-7.7-1.7-3.1 1.9-3.8-3.6-16.8 2.1-1.2-.1-.7z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "N5",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M536.1 138.9l4-4.8 1.4.2 2-5.4-1.1-.8-.2-8.4-1.1-4.3-4.1-4.5.6 2.6h-3.8l.7-2.6-2.2-2.2-5 .7-3.6-1.2-2.9 1.7-3.8-3.1.5-1.4-4.8-.7-.5 1.7c-2.4 1.4-4.1 7.7-4.1 7.7l-3.8 2.9 5 12.2 2.4 10.3 17.5 7.2.1.6 6.4-4.8.4-3.6z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "N3",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M518.2 102.6l-2.9-2.8-6.7-2.8-1.7-2.1c-1 .2-2.5-.1-2.5-.1l-.6 2-2 .3c-3.4.3-.5 4.6-.5 4.6l.2 2-3.4 1.2-2.3-1.4-4.9-2-.8.9-.9-.2.5-2.5-1.4-1.3-1.2.9-1.7 1.3-2 1.5-2.7 2-2.6 4.1-1.2 2.3-2 2-.9 1.7-1.4 1.8 15.7-.7 4.6 1.4.5-3.1-1.2-1.7 1.2-.8.6-2.6 1.5-1.4 3.6 2.5 1.5-.3 2 3.2 3.2 3.3 2.3-1.7s1.7-6.2 4.1-7.7l.5-1.7 3.5.5.5-1.4 1.5-1.2z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "N2",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M542 107.7l-3.9-5.4-2.9-3.8-2.1-2.7-.9-1.7-1.4.6-1.8-2.9-1.2-1.4-.8-1.7-1.7-.3-1.7-1.7-2.7-1.2-2.1-1.4-2.9-2.7-1.2-.4-.2 7.7-.8.9-.8-1.5h-.9l.3 2-.9.5-1.2-1.5-.9 1.7-2.8.5 1.1 1.7c.8 1.2.3 1.7-.6 1.8l1.7 2.1 6.7 2.8 2.9 2.8-1.4 1.2-.5 1.4 1.3.2-.5 1.4 3.8 3.1 2.9-1.7 3.6 1.2 5-.7 2.2 2.2-.7 2.6h3.8l-1-4.3 2.4 1 1-1.7 1.9 2.6 1.6-1.1-1.7-2.2z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "N17",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M657.7 226.8l-3.9-2.7-.3-.8-2.7 2.3-4.8 3.1s-6-1.7-6.7.5c-.7 2.2-.2 11.5-.2 11.5l2.2 2.2-.7 1.2 1.7 1.4 1.6 8.9 4-.6 2.8-7.1 1.7-2.8 1.5-3 .4-.9-.9-2.4 1.5-1.3-1.7-4.7 1.3-2.8 2.8 1.3.4 1.5h2.8l.2-2.4 2.1-1.7.1-1-5.2.3z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "N22",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M632.2 237.1l.8-.8 2.2 1.4 1.9.6 1.9-.5c-.1-2.9-.1-7.2.3-8.6.7-2.2 6.7-.5 6.7-.5l4.8-3.1 2.7-2.3-1.3-3.4c-.2-1.4.1-2.4.6-3.3l-2.3-1.5-1.4 2.4-4.8 3.1-2.2-.5v3.1l-4.3 1.2-3.6 5.5-5 7.7-.1.1 2.5 1.4.6-2z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "N1",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M557.8 55.3l-.1-1-1.5.3-.5.7.2 2-.3 1.4-.2 2.1-.4 1.3.4 3.4.8.1 2.1.5.6-1.2 1-1.7.2-1.5-2-1.1-.7-1 .1-.6.6-.3.3-.8-.9-.9-.3-1.2zM566.4 58.5l-.9 1.5-.1 1.1h-.9l-1-.6-.9 1.6-.6 1.2h-1.3l.3 2.3.4 1.4.6 1.3h1.2l.5-2.1 1.2-.4.8.1 1.5 1.5.4 1.1 1.4-.9 1.2-1.2-.6-2.8.1-1.3.2-1.4-1.2-.9zM513.5 80.8l-4.5-2.3-2 .1-6.9 8.4-2.7 2.9-1.5 1.8-3 2.7-4.1 3.6-.6.4 1.4 1.3-.5 2.5.9.2.8-.9 4.9 2 2.3 1.4 3.4-1.2-.2-2s-2.9-4.3.5-4.6l2-.3.6-2s1.4.3 2.5.1c.9-.1 1.5-.6.6-1.8l-1.1-1.7 2.8-.5.9-1.7 1.2 1.5.9-.5-.3-2h1.1l.8 1.5.8-.9.2-7.7-1.2-.3z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "N11",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M666.1 208.1l-1.3-1-2.2-3.3.2-1.4-3-4.7-3.3-4.8-2.1-1.5-1.4-.6-1.1-1-.4 1.1-.1-.1.7 2.3-.9 1.6-.8 2 1 4.4 2.4 4 2.2-1.1.4 2.2 1 .1h2.2l.7 1.9 1 2.2 2.3-1.5.7.9 3-.3z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "655.5,195.3 668.1,176.5 680,176.5  "
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "N9",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M653.8 205.1l-2.4-4-1-4.4.8-2 .9-1.6-.7-2.3-2.1-1.2-6.5.7.2 9.1-2.2-.2-5.5-4.3-8.2 1.9-.2 5.3-1.7-.7-1.9-3.4-.5-5s-1-11-4.3-6.7c0 0-3.4-.2-4.8-1.4s-5.5-4.3-5.5-4.3l-2.6 1.4 3.6 16.8-1.9 3.8 1.7 3.1.2 7.7-3.4 4.1 4.8 3.4 1.4 3.4-1.2 3.1 5.3 3.8.5 2.6 2.4.2 4.2 3.9 2.5-1.5-2.1-4.3v-2.6l2.9-.8v-1.6l-1-4.2-1.9-2.1.7-1.9 1.4.6 1.5-1.5-.3-4.4h1.3l2.7.9 2.1-1.3 3.4 2.3 2.3-1.4 2.1-.2.9-1.7 4.1-2.9s.2-3 1.7-1l.9.9 2.3-.2.4-1.8 2.4-.2.5-1.7-.2-.2z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "N10",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M655.3 212.8s.5-.7.5-1.4-2.4-.7-2.4-.7l-2.4-1.6h-.3l-2.3.2-.9-.9c-1.5-2-1.7 1-1.7 1l-4.1 2.9-.9 1.7-2.1.2-2.3 1.4-3.4-2.3-2.1 1.3-2.7-.9h-1.3l.3 4.4-1.5 1.5-1.4-.6-.7 1.9 1.9 2.1 1 4.2v1.6l-2.9.8v2.6l2.1 4.3-2.5 1.5 2.5 2.3.5-.6.4-.5-1 1.1.2.2 3.2-2.9 5-7.7 3.6-5.5 4.3-1.2v-3.1l2.2.5 4.8-3.1 1.4-2.4 2.3 1.5c.7-1.2 1.9-1.9 3-2.3l-.3-1.5z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "N13",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M663.7 221.8l-.5-.7.7-1.2-.6-.5v-1.1l.4-.4-1.3.1-1 .8-1.1.4-.3-.7.5-1c.5-1.3-1.5-.5-1.5-.5l-.3-1.6 2.1-.1.9-.9-.1-.9h-3.3s-4 .3-5.6 3c-.5.8-.8 1.9-.6 3.3l1.3 3.4.3.8 3.9 2.7 5-.1-.2-1.3 1.3-3.5z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "657.5,220.3 682.7,212.2 693.3,212.2  "
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "N18",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M660.5 229.5l-.2 2.3h-2.8l-.4-1.5-2.8-1.3-1.3 2.8 1.8 4.7-1.6 1.3.9 2.4-.4.8h3.8l.5 2.8 3.8-.8 2.6-1.3 3 .7.4-2.2-.4-2 1.7-5.8-2.1-5.8-4.2.1-.1 1z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "N20",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M726.3 325l-8.2-13.9-3.2-8.2-8-12.5-6.3-12.2-8.4 2.7-1.9-2.4 1.1-1.9-1.1-1.3h-3s-2.6-1.5-1.9-1.5 1.7-3.4 1.7-3.4l-3.9-1.7-.6-2.1.2-2.1-.9-1.3-1.9.6-2.1-1.5.4-3-3-3-6.9.6-2.1-3.4.6-2.6-.9-1.5 1.1-1.9-.2-3.2.4-1.8-3-.7-2.6 1.3-3.9.9-.4-2.8h-3.9l-1.5 3-1.7 2.8-2.8 7.1-4 .6.1.7-.7 2.4 6.7 9.6v2.6l5.5 3.1s2.6-3.8 4.8-.7c2.2 3.1 3.1 7.2 3.1 7.2l5.3 7 3.1-1.9 4.3 9.4 8.6 7.9.7 6 2.6 2.1 1 .3 1 11.5 9.8 2.6 3.4 8.2 2.4-.5 3.6-3.4 3.8 3.6 3.4 4.8 5 .2 4.6-3.4v-2.2l3.1-1.4h.5l-2.9-5.4z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "N19",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M692.8 262.5l-2-4.7-2-3-2.5-7.1-2.6-1.7-.6-3.2-2.6-3.3-.9-1.5-2.2-4.6-1.3-2.6-1.6 3-2.9-2.4-1 1.9-1 .7-.6-1.7-1.7 5.9.4 1.9-.5 2.2-.4 1.8.2 3.2-1.1 1.9.9 1.5-.6 2.6 2.1 3.4 6.9-.6 3 3-.4 3 2.1 1.5 1.9-.6.9 1.3-.2 2.1.6 2.1 3.9 1.7s-1.1 3.4-1.7 3.4 1.9 1.5 1.9 1.5h3l1.1 1.3-1.1 1.9 1.9 2.4 8.4-2.7-7.7-15.5z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "N6",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M629 169.3l-4.2-5.3h-3.1l-4.3-4.7-3.9 1.8-5.4-1.2-6.9-2.7-4.8-3.3-6.2-5.8-6.2-4.4-3-2.7-3.6-3.5-3.3-1.7-.6-1.5-1.4-1.1-1.4-.5-1.8-.2-.6-2.7-2-.3-2.9-2.3-1.8-.1-1.7-2.3-1.5-1.8-3.3-1.4-2.7-2.1-3.5-3.5-3.2-2.3-.1-.9-2.1-3-1.6 1.1-1.9-2.6-1 1.7-2.4-1 .4 1.7 4.1 4.5 1.1 4.3.2 8.4 1.1.8-2 5.4-1.4-.2-4 4.8-.3 3.6-6.4 4.8.9 4.7-1.9 4.6-.7 1.7 2.9 3.8-4.3 2.4-1.2 5-2.6 1 .8 1.9 7.4 1.7s1.4 5.8 2.2 5.8c.7 0 6 4.8 6 4.8l.7 4.8-1.4 5.3 2.4 1.9 4.8-3.1 1.3 1 1.3-1.4 2.5 2.2.8-1.5 4.6 1.1-.5-3.4 1.2-2 .2-1.7 1.4-1.1.5.9 2.3-1.1 4.6 3.9 3.9-4.3 1.5-.8 2 .2.3-3.4-.5-1.2.6-1.7 2.3.5-1.7-4.5 2.6-1.1v-1.5l-.9-3.1 4.3-3.9 1.1 1.7 5.4-3.7 2.6 1.1 1.1-5.1 2.2 4.8 2.8 1.2 1.4 2 2.9.6 3.4-.3 1.1 1.2-.9 4.9.2 4 4.5 2.2.1.8.6-.3 4.9 3.8 11.4-12.3 4.2-2.8z"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "N4",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M500.7 109.2l-1.5.3-3.6-2.5-1.5 1.4-.6 2.6-1.2.8 1.2 1.7-.5 3.1-4.6-1.4-15.7.7-1.8.6-2.6 1.2-.2 2.3.9 1.7.3 2.1 1.2 1.5-1.1 2.6 1.4 2.6-.3 2.6 1.4 1.8v2l.9.9v.6l.1 1.8-.6 5.4.6 2.6 1.5 3.9-.3 1.5.9 1.5-.9.8-1.8 2.3-1.4 2.9-1.5.9h-1.8l1.7 3.2 1.7 2.3v3.8l-.3 2.7 1.8 3 .2 2.7.6 2.6.5 2.3-3.8 2.4-1.5.2v3.5l2 1.2 2 2.4 2.1.5.8 1.4h1.7l.3 1.5 2.9 4.1 2.1-.2.8 1.4-.1.7h1l4.8 3.1 5-2.6 8.6 3.6-1 2.6 4.8 1 4.3-6.5s4.1-3.1 5-3.1c1 0 3.1.7 3.1.7l2.6-.7-2.6-4.6 2.2-3.1.2-6 1.7-2.9-.7-1.4 2.4-3.6-2.2-4.6 1-2.6-.2-.5-.8-1.9 2.6-1 1.2-5 4.3-2.4-2.9-3.8.7-1.7 1.9-4.6-1-5.3-17.5-7.2-2.4-10.3-5-12.2 1.6-1.2-3.2-3.3-1.9-3.4z"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "N12",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M661.3 210.4l-.9-2.2-.7-1.9h-2.2l-1-.1-.5-2.2-2.3 1.1.2.3-.5 1.7-2.4.2-.4 1.8h.3l2.4 1.6s2.4 0 2.4.7-.5 1.4-.5 1.4l.5 1.5c1.4-.5 2.6-.6 2.6-.6h4.3l1.2-3.8h.4l-.8-.9-2.1 1.4z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "657.5,209.6 673,189.8 689.2,189.8  "
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "text",
    transform: "matrix(1, 0, 0, 1, -17, 0)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 657.05,
    y: 513.79
  }, "\n      N32\n    "), /*#__PURE__*/React.createElement("text", {
    x: 713.38,
    y: 509.3
  }, "\n      N31\n    "), /*#__PURE__*/React.createElement("text", {
    x: 696.47,
    y: 463.8
  }, "\n      N30\n    "), /*#__PURE__*/React.createElement("text", {
    x: 719.32,
    y: 421.55
  }, "\n      N29\n    "), /*#__PURE__*/React.createElement("text", {
    x: 710.74,
    y: 389.66
  }, "\n      N28\n    "), /*#__PURE__*/React.createElement("text", {
    x: 733.01,
    y: 367.88
  }, "\n      N27\n    "), /*#__PURE__*/React.createElement("text", {
    x: 699.75,
    y: 348.1
  }, "\n      N26\n    "), /*#__PURE__*/React.createElement("text", {
    x: 628.55,
    y: 402.23
  }, "\n      N25\n    "), /*#__PURE__*/React.createElement("text", {
    x: 641.69,
    y: 302.13
  }, "\n      N24\n    "), /*#__PURE__*/React.createElement("text", {
    x: 525.54,
    y: 280.29
  }, "\n      N21\n    "), /*#__PURE__*/React.createElement("text", {
    x: 616.44,
    y: 271.46
  }, "\n      N23\n    "), /*#__PURE__*/React.createElement("text", {
    x: 682.66,
    y: 295.99
  }, "\n      N20\n    "), /*#__PURE__*/React.createElement("text", {
    x: 669.75,
    y: 253.3
  }, "\n      N19\n    "), /*#__PURE__*/React.createElement("text", {
    x: 708.12,
    y: 240.71
  }, "\n      N16\n    "), /*#__PURE__*/React.createElement("text", {
    x: 726.29,
    y: 228.01
  }, "\n      N15\n    "), /*#__PURE__*/React.createElement("text", {
    x: 687.35,
    y: 205.76
  }, "\n      N14\n    "), /*#__PURE__*/React.createElement("text", {
    x: 681.53,
    y: 180.46
  }, "\n      N11\n    "), /*#__PURE__*/React.createElement("text", {
    x: 690.35,
    y: 193.01
  }, "\n      N12\n    "), /*#__PURE__*/React.createElement("text", {
    x: 623.89,
    y: 186.65
  }, "\n      N8\n    "), /*#__PURE__*/React.createElement("text", {
    x: 628.99,
    y: 205.67
  }, "\n      N9\n    "), /*#__PURE__*/React.createElement("text", {
    x: 616.44,
    y: 223.34
  }, "\n      N10\n    "), /*#__PURE__*/React.createElement("text", {
    x: 567.28,
    y: 211
  }, "\n      N7\n    "), /*#__PURE__*/React.createElement("text", {
    x: 694.02,
    y: 217.85
  }, "\n      N13\n    "), /*#__PURE__*/React.createElement("text", {
    x: 558.93,
    y: 153.71
  }, "\n      N6\n    "), /*#__PURE__*/React.createElement("text", {
    x: 517.82,
    y: 129.28
  }, "\n      N5\n    "), /*#__PURE__*/React.createElement("text", {
    x: 498.85,
    y: 167.4
  }, "\n      N4\n    "), /*#__PURE__*/React.createElement("text", {
    x: 479.9,
    y: 110.57
  }, "\n      N3\n    "), /*#__PURE__*/React.createElement("text", {
    x: 515.13,
    y: 102.64
  }, "\n      N2\n    "), /*#__PURE__*/React.createElement("text", {
    x: 633.82,
    y: 247.16
  }, "\n      N17\n    "), /*#__PURE__*/React.createElement("text", {
    x: 650.8,
    y: 238.4
  }, "\n      N18\n    "), /*#__PURE__*/React.createElement("text", {
    x: 636.19,
    y: 227.11
  }, "\n      N22\n    "), /*#__PURE__*/React.createElement("text", {
    x: 491.85,
    y: 91.82
  }, "\n      N1\n    "))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDTerengganu);
export default __webpack_public_path__ + "static/media/d_terengganu.0e38c257.svg";
export { ForwardRef as ReactComponent };